<template>
  <div class="fruit-details px-5 mt-5">
    <!--  -->
    <div
      class="cover text-center mb-3 d-flex align-center justify-space-around mt-6"
      :key="selectedFruit.sufficiency"
    >
      <div v-if="selectedFruit.sufficiency">
        <span class="d-block font-bold font-25 primary--text"
          >نسبة الاكتفاء</span
        >
        <span class="font-30 font-bold grey--text mb-0 d-block">
          {{ selectedFruit.sufficiency }} %
        </span>
      </div>
      <div class="cover-line" v-if="selectedFruit.sufficiency"></div>
      <div>
        <span class="d-block font-bold font-25 primary--text"
          >كمية الإنتاج</span
        >
        <span class="font-30 font-bold grey--text mb-0 d-block">
          {{ selectedFruit.produce || "-" }}</span
        >
      </div>
    </div>

    <div class="cover text-center mb-3" :key="selectedFruit.sufficiency">
      <span class="d-block font-bold font-25 primary--text"
        >الأنواع والأصناف</span
      >
      <p
        class="font-20 font-500 grey--text mb-0"
        v-if="selectedFruit.types.length > 0"
      >
        <span v-for="(type, i) in selectedFruit.types" :key="i"
          >{{ type }} <span v-if="i <= selectedFruit.types.length - 2">-</span>
        </span>
      </p>
      <span class="font-20 font-500 grey--text mb-0">-</span>
    </div>
    <div class="cover text-center mb-14">
      <span class="d-block font-bold font-25 primary--text mb-3"
        >الفوائد الصحية</span
      >
      <div class="text-right" v-if="selectedFruit.benefits.length > 0">
        <div class="d-flex justify-end" v-for="(benefit, i) in selectedFruit.benefits" :key="i">
          <p class="font-20 font-500 grey--text mb-1">{{ benefit }}</p>
          <span class="circle-dot mx-1 d-inline-block ml-4">•</span>
        </div>
      </div>
      <div>
        <p class="font-20 font-500 grey--text mb-1">-</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedFruit: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.fruit-details {
  .cover {
    background: #e4ece9;
    border-radius: 6px;
    padding: 12px 20px 22px 20px;
    text-align: center;
    animation: coverFade 1s forwards;
  }
  .cover-line {
    height: 80px;
    width: 2px;
    background: $primary;
    border-radius: 7px;
  }
  p {
    direction: rtl;
  }
}

@keyframes coverFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
